import { render, staticRenderFns } from "./PartnerBusiness.vue?vue&type=template&id=49048201&scoped=true"
import script from "./PartnerBusiness.vue?vue&type=script&lang=js"
export * from "./PartnerBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49048201",
  null
  
)

export default component.exports